<div class="message-box-wrapper">
  <div class="content">
    <mat-icon *ngIf="messageBoxData?.icon as icon" [ngClass]="icon">{{ icon }}</mat-icon>
    <h4 class="mb-0">{{ messageBoxData?.text }}</h4>
  </div>
  <div class="button-row">
    <button aria-label="close" mat-dialog-close mat-raised-button class="close-button">
      {{ 'PopupForm:Close' | translate }}
    </button>
  </div>
</div>
